import React, {useEffect, useState} from "react";
import styled from "styled-components";


export const Tab = ({data, onChange, ...props}) => {
	const [index, setIndex] = useState(0);

	useEffect(() => {
		setIndex(props.index);
	}, [props.index]);
	
	const eventHandler = {
		changeIndex : (index) => {
			setIndex(index);
			if(onChange) onChange(index);
		}
	};

	const getTop = () => {
		const focusIndex = index;
		const li = (data || []).map((item, index) => {
			const className = (index == focusIndex) ? "focus" : null;
			return (
				<li key={index} className={className}>
					<a data-index={index} onClick={() => {eventHandler.changeIndex(index)}}>{item.name}</a>
				</li>
			);
		});
		return (<ul>{li}</ul>);
	};
	
	const getMiddle = () => {
		const isComponent = (data[0] && data[0].component);
		if(!isComponent) return null;
		
		const focusIndex = index;
		const li = (data || []).map((item, index) => {
			const className = (index == focusIndex) ? "focus" : null;
			return (
				<li key={index} className={className}>
					{(index == focusIndex) ? item.component : null}
				</li>
			);
		});
		return (<ul>{li}</ul>);
	};
	
	return (
		<Wrapper {...props}>
			<div className="top">
				{getTop()}
			</div>
			<div className="middle">
				{getMiddle()}
			</div>
		</Wrapper>
	);
};

const Wrapper = styled.div`
& > .top					{position:relative; margin-bottom:10px}
& > .top ul					{display:flex; padding:4px; align-items:center; justify-content:space-between; background-color:#eaeffb; border-radius:4em; text-align:center; font-size:1rem; font-weight:500}
& > .top ul li				{position:relative; width:100%; border-radius:4em}
& > .top ul li a			{display:block; padding:7px}
& > .top ul li.focus		{background-color:white; font-weight:bold; color:var(--blue)}
& > .top div				{position:absolute; left:0; bottom:0; border-top:2px solid var(--blue); transition:left 0.25s}

& > .middle > ul > li		{display:none}
& > .middle > ul > li.focus	{display:block}
`;

export default Tab;